import { useState, useRef } from 'react'
import { Card, Row, Col, Avatar, Tag, Button, Popconfirm, message } from "antd";
import { UserOutlined } from '@ant-design/icons';
import { Operation } from "./operation"
import { ReloadOutlined } from '@ant-design/icons';
import { langCommon, langPage } from '../../locales';
import { CommonServer } from "./../../server";
import { useRequest } from "ahooks";

const server = CommonServer.Mine;
const lang = langPage?.mine

export const Mine = () => {
    const operationRef: any = useRef();
    const [userInfo, setUserInfo] = useState({ ...JSON.parse(sessionStorage.getItem('userInfo')!) })
    const [loading, setLoading] = useState<boolean>(false);

    const { run } = useRequest(server.refresh, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onSuccess: (res: any) => {
            let currInfo = { ...userInfo };
            currInfo.InviteCode = res;
            sessionStorage.setItem('userInfo', JSON.stringify(currInfo))
            setUserInfo(currInfo);
            message.success(langCommon?.refreshSuccess);
        }
    });

    return (
        <div>
            <Row gutter={20}>
                <Col span={24}>
                    <Card>
                        <div className="flex flex-column align-center">
                            <Avatar src={userInfo.Avatar} size={48} icon={<UserOutlined />} />
                            <div className="mt20 fb">{userInfo.Username}</div>
                            <div className="mt20 flex flex-center">
                                邀请码：<Tag color="processing">{userInfo.InviteCode}</Tag>
                                <Popconfirm
                                    title={lang?.refresh}
                                    onConfirm={() => {
                                        run()
                                    }}>
                                    <Button loading={loading} size='small' type="primary"><ReloadOutlined /> {langCommon?.refresh} </Button>
                                </Popconfirm>
                            </div>
                            <Tag className="mt20">用户id：{userInfo.Id}</Tag>
                            <Tag className="mt20">注册时间：{userInfo.CreatedAt}</Tag>
                        </div>
                    </Card>
                    <Card title="修改密码" className="mt10">
                        <div className="flex space-between">
                            <div className="mr20">定期修改为高强度密码，以保护您的账号</div>
                            <Button type="primary"
                                onClick={() => {
                                    operationRef.current?.changeVisible(true, 'password')
                                }}
                            >立即修改</Button>
                        </div>
                    </Card>
                    <Card title="修改账号" className="mt20">
                        <div className="flex space-between">
                            <div className="mr20">更改账号</div>
                            <Button
                                type="primary"
                                onClick={() => {
                                    operationRef.current?.changeVisible(true, 'account')
                                }}
                            >立即修改</Button>
                        </div>
                    </Card>
                </Col>
            </Row>

            <Operation ref={operationRef} />
        </div>
    );
}